import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { OrganizationManager } from "../organization-manager";
import { Team } from "../team/entity";

import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import { type TeamManager } from "./entity";

export const TeamManagerEntityConfig: HyperEntityConfig<TeamManager> = {
  allowApiRead: Roles.AdminsAndManager,
  allowApiCrud: Roles.SuperAdmin,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      manager: {
        $is: await copyApiPrefilterPerRole(OrganizationManager),
      },
    });

    filter(Roles.All, {
      team: {
        $is: await copyApiPrefilterPerRole(Team),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmin, (entity) =>
      doesExist(
        OrganizationManager,
        OrganizationManager.hyperFilter({
          id: entity.managerId,
          organization: {
            $is: {
              id: remult.user!.organizationId,
              teams: {
                $some: {
                  id: entity.teamId,
                },
              },
            },
          },
        }),
      ),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperAdmin, {
      manager: {
        $is: {
          organization: {
            $id: remult.user!.organizationId,
          },
        },
      },
      team: {
        $is: {
          organization: {
            $id: remult.user!.organizationId,
          },
        },
      },
    });
  },

  id: {
    managerId: true,
    teamId: true,
  },
};
